import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BUILD_VERSION, BUILD_NUMBER } from './version';

// Log build version in console
console.log(`%cBuild Version: ${BUILD_VERSION}`, 'color: #4285f4; font-weight: bold;');
console.log(`%cBuild Number: ${BUILD_NUMBER}`, 'color: #ea4335; font-weight: bold;');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
